export class QuickJSON
{
  static parse( value:string )
  {
    var valueBefore =value;
    value = value.trim();

    var regexFirst = /^\s*(\w+\s*)\:/ig;
    var regexFollowing = /\,\s*(\w+\s*)\:/ig;
    value = value.replace( regexFirst, "\"$1\":" )
    value = value.replace( regexFollowing, ",\"$1\":" );
    value = "{" + value + "}";

    console.log( "QuickJson", valueBefore, ">>", value );

    return JSON.parse( value );
  }
}